import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ebfda7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "RecommendShop guideDom-channel-all-3" }
const _hoisted_2 = { class: "RecommendShop-header" }
const _hoisted_3 = { class: "RecommendShop-shoptab" }
const _hoisted_4 = { class: "RecommendShop-window" }

import { reactive, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import TabSwitchArrow from '@/components/common/TabSwitchArrow.vue'
import ShopWindow from '@/components/common/ShopWindow.vue'
import { getRecommendShopList, getShopDetail as getShopDetailRes } from '@/apis/shop'
import { useStore } from 'vuex'
import { useRequest } from '@/util/useLoading'
import { bury } from '@/util/useBury'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: t('推荐档口')
  },
  // 来源渠道 null-我的频道 1-市场购 2-透明购（平台频道）
  channel: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props
const store = useStore()

const stationCode = useSite2Station()

onMounted(() => {
  getList()
})



const data: any = reactive({
  // 当前选中档口的id
  curId: '',
  // 当前选中的item
  curItem: null,
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 8,
    total: 0
  }
})

// onMounted(() => {
//   // 初始化是查询的是list，listItem中的shopMajorCateName没有翻译，所以触发一次详情的查询
//   getShopDetail(data.curId)
// })
// tab选中
const tabSelected = (id: any, item: any) => {
  data.curId = id
  // data.curItem = item
  if (!props.channel) {
    bury('MyChannel_Click_RecommendShop')
  }
  getShopDetail(item.shopCode)
}

// 获取店铺列表
const getList = () => {
  const formData = {
    // 为0-我的频道时channel不传
    channel: props.channel === '0' ? null : props.channel,
    mallCategoryId: props.channel === '1' ? store.state.market.type : null,
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    stationCode
  }
  getRecommendShopList(formData).then((res: any) => {
    if (res?.code === '0') {
      if (formData.pageNum === 1) {
        data.list = res.data.records
        data.page.total = res.data.total
        if (data.list.length !== 0) {
          data.curId = data.list[0].shopCode
          data.curItem = data.list[0]
        }
      } else {
        data.list = data.list.concat(res.data.records)
      }
    }
  })
}

// 获取店铺信息
const [detailLoading, getShopDetail] = useRequest((shopCode: any) => {
  const formData = {
    shopCode,
    pageNum: 1,
    pageSize: 8,
    sortType: 'product_sell_quantity',
    descendOrder: true,
    // mallCategoryId: props.channel === '1' ? store.state.market.type : null,
    footprint: false // 不记录足迹
  }
  return getShopDetailRes(formData).then((res: any) => {
    if (res.code === '0') {
      data.curItem = {
        ...res.data.supplierRespDTO,
        recommendProductList: res.data.productPage.records
      }
    } else if (res.code === '24100006') {
      data.curId = data.curItem.shopCode
    }
  })
})

const pageChange = (page: number) => {
  if (!props.channel) {
    bury('MyChannel_Click_RecommendShopMore')
  }
  data.page.currentPage = page
  getList()
}

// item不喜欢操作回调
const itemUnlike = (shopCode: string) => {
  const index = data.list.findIndex((item: any) => item.shopCode === shopCode)
  data.list.splice(index, 1)
  data.curItem = data.list[index] ? data.list[index] : data.list[index - 1]
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TabSwitchArrow, {
        list: _unref(data).list,
        curId: _unref(data).curId,
        "onUpdate:selected": tabSelected,
        "onUpdate:pageNum": pageChange
      }, null, 8, ["list", "curId"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(ShopWindow, {
        item: _unref(data).curItem,
        onUnlike: itemUnlike
      }, null, 8, ["item"])
    ], 512), [
      [_directive_loading, _unref(detailLoading)]
    ])
  ], 512)), [
    [_vShow, _unref(data).list.length !== 0]
  ])
}
}

})